import { Controller } from "@hotwired/stimulus"
import { appendJumpFields } from "../helpers/jump_fields"

// The confirm button is rendered `disabled` server-side so the required-reason
// guard holds even before this controller hydrates.
export default class extends Controller {
  static targets = ["dialog", "reason", "confirm"]
  static values = { url: String, id: String, jump: Boolean }

  open() {
    this.reasonTarget.value = ""
    this.validate()
    this.dialogTarget.showModal()
    this.reasonTarget.focus()
  }

  close() {
    this.dialogTarget.close()
  }

  backdropClick(event) {
    if (event.target === this.dialogTarget) this.close()
  }

  validate() {
    this.confirmTarget.disabled = this.reasonTarget.value.trim() === ""
  }

  confirm() {
    const reason = this.reasonTarget.value.trim()
    if (reason === "") return

    const form = document.createElement("form")
    form.method = "post"
    form.action = this.urlValue
    form.style.display = "none"

    const token = document.querySelector('meta[name="csrf-token"]')?.content
    if (token) form.appendChild(this.hidden("authenticity_token", token))
    if (this.hasIdValue && this.idValue) form.appendChild(this.hidden("ids[]", this.idValue))
    form.appendChild(this.hidden("reason", reason))
    form.appendChild(this.hidden("reason_required", "1"))
    if (this.jumpValue) appendJumpFields(this, form)

    document.body.appendChild(form)
    if (form.requestSubmit) form.requestSubmit()
    else form.submit()
  }

  hidden(name, value) {
    const input = document.createElement("input")
    input.type = "hidden"
    input.name = name
    input.value = value
    return input
  }
}
